import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';
import Card from './Card';
import Jukebox from './Jukebox';
import CardPrint from './CardPrint';
import './App.scss';
import React, { useEffect, useState } from 'react';
import { generateCodeVerifier, generateCodeChallenge } from './auth';

import Songs from './data';

const songList = []
Object.values(Songs).forEach(countries => {
  Object.values(countries).forEach(country => {
    if(country.spotify && country.spotify.length > 0) {
        songList.push(country);
    }
  });
});

const CLIENT_ID = 'cf3bae6e8cfa4c63992247193143fce0';
const REDIRECT_URI = 'https://app.songsort.eu/';
const SCOPES = [
  'streaming',
  'user-read-email',
  'user-read-private',
  'user-modify-playback-state',
  'user-read-playback-state'
];
const AUTH_ENDPOINT = 'https://accounts.spotify.com/authorize';
const TOKEN_ENDPOINT = 'https://accounts.spotify.com/api/token';

function decodeBase64(str) {
  try {
    return decodeURIComponent(
      atob(str)
        .split('')
        .map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join('')
    );
  } catch (e) {
    return '0000/NA';
  }
}

// Read cookie helper
const getCookie = (name) => {
    const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
};

// Set cookie helper
const setCookie = (name, value, maxAgeSeconds) => {
    document.cookie = `${name}=${value}; max-age=${maxAgeSeconds}; path=/; Secure; SameSite=Lax`;
};


function SongRoute({accessToken, loginWithSpotify}) {
  const { code } = useParams();
  const decoded = decodeBase64(code).split('/');
  const year = Songs[decoded[0]];
  const country = year ? year[decoded[1]] : null;

  if (!country) {
    return (
      <div style={{ padding: 20 }}>
        <h1>404 - {decoded[0]} - {decoded[1]}</h1>
      </div>
    );
  }

  setCookie('last_song', window.location, 3600);

  // Optionally, show a loading indicator or fallback
  return (
      !accessToken ? (
        <div  style={{ padding: 20 }} className="loginscreen">
            <div className="loginscreen">
                <button onClick={loginWithSpotify}>Login with Spotify</button>
            </div>
        </div>
      ) : (
        <div  style={{ padding: 20 }}>
          <Jukebox accessToken={accessToken} song={country} />
        </div>
      )
  );
}

function MainApp({accessToken, loginWithSpotify, useWithoutSpotify, justQR}) {
  const randomElement = songList[Math.floor(Math.random() * songList.length)];
  return (
    <div style={{ padding: 20 }}>
      <h1>Great ESC App v2</h1>
      <div className="card-holder">
        {justQR ? <Card song={randomElement}/> : <button onClick={useWithoutSpotify}>Logout to see cards</button> }
      </div>
    </div>
  );
}

// Wrap everything in Router
export default function App() {
  const [accessToken, setAccessToken] = useState('');
  const [useJustQRCodes, setUseJustQRCodes] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    const code = urlParams.get('code');
    const storedVerifier = localStorage.getItem('code_verifier');
    const tokenFromCookie = getCookie('access_token');
    if (tokenFromCookie) {
      setAccessToken(tokenFromCookie);
      return;
    } else {
      setUseJustQRCodes(true);
    }

    if (code && storedVerifier) {
      const body = new URLSearchParams({
        client_id: CLIENT_ID,
        grant_type: 'authorization_code',
        code,
        redirect_uri: REDIRECT_URI,
        code_verifier: storedVerifier,
      });

      fetch(TOKEN_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body
      })
        .then(res => res.json())
        .then(data => {
          if (data.access_token) {
            setAccessToken(data.access_token);
            setCookie('access_token', data.access_token, data.expires_in || 3600);
            const lastSongFromCookie = getCookie('last_song');
            if (lastSongFromCookie) {
                setCookie('last_song', '', -99999999);
                window.location.href = lastSongFromCookie;
            }
          } else {
            console.error('Failed to get access token:', data);
          }
          setUseJustQRCodes(true);
        });
    }
  }, []);

  const useWithoutSpotify = async () => {
    setCookie('access_token', '', -999999999);
    window.location.reload();
  };

  const loginWithSpotify = async () => {
    setUseJustQRCodes(false)
    const verifier = generateCodeVerifier();
    const challenge = await generateCodeChallenge(verifier);

    localStorage.setItem('code_verifier', verifier);

    const params = new URLSearchParams({
      response_type: 'code',
      client_id: CLIENT_ID,
      scope: SCOPES.join(' '),
      redirect_uri: REDIRECT_URI,
      code_challenge_method: 'S256',
      code_challenge: challenge,
    });

    window.location.href = `${AUTH_ENDPOINT}?${params.toString()}`;
  };

  return (
    <Router>
      <Routes>
        <Route path="/songs/:code" element={<SongRoute accessToken={accessToken} loginWithSpotify={loginWithSpotify} />} />
        <Route path="/cards/print/:side" element={<CardPrint />} />
        <Route path="*" element={<MainApp accessToken={accessToken} loginWithSpotify={loginWithSpotify} justQR={useJustQRCodes} useWithoutSpotify={useWithoutSpotify}/>} />
      </Routes>
    </Router>
  );
}
